import { useCurrentDialog } from "@/GlobalData";
import M3textedit from "@/common/components/m3textedit";
import { User } from "@/common/data/User";
import M3ripple from "@/common/components/m3ripple";
import { generateLocalDate, loadDateFromISOString, saveDateToStringWithTimezone } from "@/common/utils/DateTools";
import { useImmer } from "use-immer";
import { SerializedDate } from "@/common/data/Data";

export function ChangeBirthday({ oldbirthday, modify }: { oldbirthday: SerializedDate, modify: (modifier: (draft: User) => void) => Promise<User> }) {
    const loaded = loadDateFromISOString(oldbirthday) ?? new Date();
    const [state, setState] = useImmer({
        year: loaded?.getFullYear(),
        month: loaded?.getMonth(),
        DoM: loaded?.getDate(),
        loading: false,
        error: {
            isError: false
        } as {
            isError: false
        } | {
            isError: true,
            errorReason: string
        }
    })
    const currentDialog = useCurrentDialog();
    const handleSubmit = async (e: unknown) => {
        // This function only runs if all HTML validations pass
        const e2 = e as FormDataEvent
        e2.preventDefault();
        try {
            generateLocalDate(state.year, state.month, state.DoM);
        } catch (e: unknown) {
            const parsed = e as Error;
            setState(x => {
                x.error = {
                    isError: true,
                    errorReason: parsed.message
                }
            })
            return;
        }
        setState((x) => { x.loading = true })
        console.log(state)
        await modify((x) => {
            x.ulangTahun = saveDateToStringWithTimezone(generateLocalDate(state.year, state.month, state.DoM)!);
        })
        setState((x) => { x.loading = false })
        currentDialog.hideDialog()
    };

    return <form className="w-full size-lf-stretch inline-flex flex-col justify-start items-start gap-2.5 overflow-hidden" onSubmit={handleSubmit}>

        <div className="self-stretch inline-flex justify-start items-start gap-2.5 flex-wrap content-start">
            <div className="flex-1 rounded-lg outline outline-1 outline-offset-[-1px] outline-black flex justify-start items-center gap-2.5 overflow-hidden">
                {/* @ts-expect-error: Invalid cast */}
                <M3textedit type="number" className="w-full" placeholder={"Tanggal"} required min="1" max="31" value={state.DoM} onInput={(e) => {
                    setState(x => {
                        try {
                            x.DoM = Number.parseInt((e.target as HTMLInputElement).value);
                        } catch { /* empty */ }
                    })
                }} />
            </div>
            <div className="flex-1 rounded-lg outline outline-1 outline-offset-[-1px] outline-black flex justify-start items-center gap-2.5 overflow-hidden">
                {/* @ts-expect-error: Invalid cast */}
                <M3textedit type="number" className="w-full" placeholder={"Bulan"} required min="1" max="12" value={state.month} onInput={(e) => {
                    setState(x => {
                        try {
                            x.month = Number.parseInt((e.target as HTMLInputElement).value);
                        } catch { /* empty */ }
                    })
                }} />
            </div>
        </div>
        <div className="self-stretch h-max outline-offset-[-1px] outline-black inline-flex justify-start items-center gap-3 overflow-hidden">
            {/* @ts-expect-error: Invalid cast */}
            <M3textedit type="number" className="w-full" placeholder={"Tahun"} required min="1921" max="9999" value={state.year} onInput={(e) => {
                setState(x => {
                    try {
                        x.year = Number.parseInt((e.target as HTMLInputElement).value);
                    } catch { /* empty */ }
                })
            }} />
        </div>
        {state.error.isError ? <div className="text-red-600">{state.error.errorReason}</div> : <></>}
        <div className="self-stretch flex-1 py-2.5 flex flex-col justify-start items-start gap-2.5 overflow-hidden ">
            <button type="submit" className="relative size- px-3.5 py-3 bg-neutral-100 rounded-md outline outline-1 outline-offset-[-1px] outline-teal-900 inline-flex justify-start items-start gap-1">
                <div className="justify-start text-zinc-600 text-lg font-normal font-['Be_Vietnam_Pro']">Submit</div>

                <M3ripple />
            </button>
        </div>
    </form >;
}